import * as React from "react";
import { forwardRef } from "react";
const SvgIcPlayerPlay = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9 32.9996L10.5087 33.8605L32.5087 20.8605V19.1387L10.5087 6.13867L9 6.9996V32.9996Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcPlayerPlay);
export { ForwardRef as ReactComponent };
